import { ComponentStore } from '@ngrx/component-store';
import {  tapResponse } from '@ngrx/operators';
import { SageSettingsService } from './sage-settings.service';
import { Injectable } from '@angular/core';
import { mergeMap, pipe } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';

interface SageSettingsState {
  status: 'unknown' | 'connecting' | 'connected' | 'disconnected' | 'error';
  accounts: any[];
  taxRates: any[];
  loading: boolean;
}

const initialState: SageSettingsState = {
  status: 'unknown',
  accounts: [],
  taxRates: [],
  loading: false
};

@Injectable()
export class SageSettingsStore extends ComponentStore<SageSettingsState> {
  constructor(
    private sageSettingsService: SageSettingsService,
    private router: Router,
    private toastService: ToastrService
  ) {
    super(initialState);
  }

  readonly status$ = this.select((state) => state.status);
  readonly accounts$ = this.select((state) => state.accounts);
  readonly taxRates$ = this.select((state) => state.taxRates);
  readonly loading$ = this.select(({ loading }) => loading);

  private readonly getConnectedStatus = this.effect(() => {
    this.patchState({ loading: true });
    return this.sageSettingsService.getSageStatus().pipe(
      tapResponse(
        (data: { connected: boolean }) => {
          this.patchState({
            status: data.connected ? 'connected' : 'disconnected'
          });
        },
        (error) => {
          console.log(error);
        },
        () => this.patchState({ loading: false })
      )
    );
  });

  readonly importCustomers = this.effect<void>(
    pipe(
      tap(() => this.patchState({ loading: true })),
      mergeMap(() => {
        return this.sageSettingsService.importCustomers().pipe(
          tapResponse(
            (response) => {
              this.toastService.success(
                response.info,
                'Customers imported successfully'
              );
            },
            (error) => {
              console.log(error);
              this.toastService.error('Unable to import customers');
            },
            () => this.patchState({ loading: false })
          )
        );
      })
    )
  );
}
